import { render } from "./SlideQuestion.vue?vue&type=template&id=a90def78&scoped=true&ts=true"
import script from "./SlideQuestion.vue?vue&type=script&lang=ts"
export * from "./SlideQuestion.vue?vue&type=script&lang=ts"

import "./SlideQuestion.vue?vue&type=style&index=0&id=a90def78&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a90def78"]])

export default __exports__